import { render, staticRenderFns } from "./BookkeepingNavigation.vue?vue&type=template&id=23a4b4a8&scoped=true&"
import script from "./BookkeepingNavigation.vue?vue&type=script&lang=js&"
export * from "./BookkeepingNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BookkeepingNavigation.vue?vue&type=style&index=0&id=23a4b4a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a4b4a8",
  null
  
)

export default component.exports